export const categories = [
  {
    id: 'circadian',
    name: 'Circadian Health',
    habits: [
      { id: 'morning-light', name: 'Morning Sunlight', defaultTarget: 7 },
      { id: 'evening-light', name: 'Evening Sunset', defaultTarget: 7 },
      { id: 'blue-light', name: 'Blue Light Control', defaultTarget: 7 },
      { id: 'dark-room', name: 'Dark Room Sleep', defaultTarget: 7 }
    ]
  },
  {
    id: 'sleep',
    name: 'Sleep',
    habits: [
      { id: 'sleep-mask', name: 'Sleep Mask', defaultTarget: 7 },
      { id: 'same-bedtime', name: 'Same Bed Time', defaultTarget: 7 },
      { id: 'no-screens', name: 'No Screens Before Bed', defaultTarget: 7 },
      { id: 'cool-room', name: 'Cool Room Temperature', defaultTarget: 7 }
    ]
  },
  {
    id: 'nutrition',
    name: 'Nutrition',
    habits: [
      { id: 'no-late-meals', name: 'No Late Meals', defaultTarget: 7 },
      { id: 'caffeine-cutoff', name: 'Caffeine Cutoff', defaultTarget: 7 },
      { id: 'hydration', name: 'Hydration', defaultTarget: 7 },
      { id: 'protein-goal', name: 'Protein Goal', defaultTarget: 7 }
    ]
  },
  {
    id: 'recovery',
    name: 'Recovery',
    habits: [
      { id: 'meditation', name: 'Meditation', defaultTarget: 7 },
      { id: 'cold-exposure', name: 'Cold Exposure', defaultTarget: 5 },
      { id: 'sauna', name: 'Sauna', defaultTarget: 3 },
      { id: 'mobility', name: 'Mobility Work', defaultTarget: 5 }
    ]
  },
  {
    id: 'supplements',
    name: 'Supplements',
    habits: [
      { id: 'magnesium', name: 'Magnesium', defaultTarget: 7 },
      { id: 'vitamin-d', name: 'Vitamin D', defaultTarget: 7 },
      { id: 'omega-3', name: 'Omega-3', defaultTarget: 7 },
      { id: 'creatine', name: 'Creatine', defaultTarget: 7 }
    ]
  }
];